import { marketId } from './index';
import { routesForMarket, type SiteRouteId } from './siteRoutes';

/**
 * Which registry routes exist in THIS build's market.
 *
 * `src/config/siteRoutes.js` is the registry; this is the one derivation of it
 * the bundle needs at runtime. Two kinds of consumer use it:
 *
 *   1. `src/App.tsx` — a route the market does not carry is never registered,
 *      so it falls through to the catch-all and 404s. That is deliberate: a 404
 *      is the correct signal for Google to drop a URL that must not exist on
 *      that domain, where a redirect to '/' would launder it into a soft 200.
 *   2. Nav/footer chrome — a link to a route this market does not carry is a
 *      site-wide link to a 404, which on a new domain is a real crawl problem.
 *
 * The market is fixed for the life of the bundle, so this is computed once at
 * module init rather than per render.
 */
const LIVE_ROUTE_IDS = new Set(routesForMarket(marketId).map((route) => route.id));

/**
 * True when the registry route with this id is part of the current market.
 *
 * `SiteRouteId` rather than `string` on purpose: a mistyped id would otherwise
 * be permanently false, silently dropping a route from the build with nothing
 * red anywhere. Now it is a compile error.
 */
export function isLive(routeId: SiteRouteId): boolean {
  return LIVE_ROUTE_IDS.has(routeId);
}
